import React, { createContext, useContext, useState } from "react";
import { Navigate } from "react-router-dom";

const OnboardingContext = createContext(null);

export const OnboardingProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [qris, setQris] = useState(null);

  const saveStep = (stepData) => {
    setData(prev => ({ ...prev, ...stepData }));
  };

  const saveQris = (qrisData) => {
    setQris(qrisData);
  };

  const clear = () => {
    setData({});
    setQris(null);
  };


  return (
    <OnboardingContext.Provider value={
      {  
        data,
        qris,
        saveStep,
        saveQris,
        clear 
      }
      }>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const ctx = useContext(OnboardingContext);
  if (!ctx) {
    throw new Error("useOnboarding must be used inside OnboardingProvider");
  }
  return ctx;
};

export const OnboardingGuard  = ({ allowIf, redirectTo, children }) => {
  const onboarding = useOnboarding();

  if (!allowIf(onboarding)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};